import { Injectable } from '@angular/core';

import { ApiService }                    from '../../api/api.service';
import { CodeTypeModel }                 from '../../core/models/code-type';
import { TableQueryParameters }          from '../../table/types/table-query-parameters';
import { TransactionCenterFiltersModel } from '../typings/transaction-center.filters';
import { TransactionCenterOrderModel }   from './typings/transaction-center.order';

@Injectable({
  providedIn: 'root'
})
export class TransactionCenterOrdersService {
  public broadcastKey  = 'filterTransactionCenterOrders';
  public tableCacheKey = 'transactionCenterOrders';

  constructor (
    private apiService: ApiService
  ) {}

  get ( filters : TransactionCenterFiltersModel = {}, params : TableQueryParameters = {} ) : Promise<Array<TransactionCenterOrderModel>> {
    return this.apiService.get('/transaction_center/purchase_orders', [
        filters.startDate       || '*',
        filters.endDate         || '*',
        filters.outstandingOnly || false,
        filters.status          || '*',
        filters.value           || '*',
        params.field            || 'order_date',
        params.direction        || 'desc',
        params.pageSize         || 10,
        params.offset           || 0
      ]);
  }

  getCount ( filters : TransactionCenterFiltersModel = {} ) : Promise<number> {
    return this.apiService.get('/transaction_center/purchase_orders_count', [
        filters.startDate       || '*',
        filters.endDate         || '*',
        filters.outstandingOnly || false,
        filters.status          || '*',
        filters.value           || '*'
      ])
      .then(( count : any ) => count.purchase_orders_count);
  }

  getStatuses () : Promise<Array<CodeTypeModel>> {
    return this.apiService.get('/system/purchase_order_status_types');
  }
}
